import { Component, Input, ViewEncapsulation } from '@angular/core';

import { CommonUtils } from 'src/shared/utils/common-utils';
import urlUtils from 'src/shared/utils/url-utils';

@Component({
  selector: 'tidy-lock-code',
  template: `
    <div *ngIf="pin" class="lock-code-card">
      <div class="lock-code-card__head">
        <tidy-image
          [src]="'assets/svg/keypad-outline.svg'"
          class="body-size">
        </tidy-image>
        <tidy-text
          [smallBody]="(displayName || 'Lock code')"
          [translate]="false">
        </tidy-text>
      </div>
      <div class="lock-code-card__digits" (click)="copy()">
        <span class="lock-code-card__digit" *ngFor="let digit of digits">{{ digit }}</span>
      </div>
      <div class="lock-code-card__copy">
        <tidy-image
          [src]="'assets/svg/copy-outline.svg'"
          class="body-size"
          (action)="copy()">
        </tidy-image>
        <tidy-text
          [body]="'Copy code'"
          class="link"
          (action)="copy()">
        </tidy-text>
      </div>
    </div>
  `,
  styleUrls: ['./lock-code.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LockCodeComponent {
  @Input() pin: string;
  @Input() displayName: string;

  constructor(private utils: CommonUtils) {}

  get digits(): string[] {
    return this.pin ? `${this.pin}`.split('') : [];
  }

  copy(): void {
    if (!this.pin) {
      return;
    }
    urlUtils.copyToClipBoard(`${this.pin}`);
    this.utils.showSuccess('Copied to clipboard!');
  }
}
